import shave from 'shave';

(function ($, window, document) {
    if(document.querySelector('.quote-column-wrapper') !== null) {
        /**
         * Get Outer-Height (Equivalent to jQuery outerHeight(true))
         *
         * @param {HTMLElement} el
         * @return {number}
         */
        const getOuterHeightOfElement = (el) => {
            if (el === null) {
                return 0;
            }
            let height = el.offsetHeight;
            const style = getComputedStyle(el);

            height += parseInt(style.marginTop) + parseInt(style.marginBottom);
            return height;
        }

        /**
         * Expand or minimize a Quote
         *
         * @param element
         */
        const expandQuote = (element) => {
            const parent = element.closest('.quote-column-wrapper');

            if (parent.classList.contains('minimized')) {
                parent.classList.remove('minimized');
                cutAllTexts();
            } else {
                parent.classList.add('minimized');
            }
        }

        /**
         * Cut all Quote-Texts with the Class `quote-text__trimmed`
         */
        const cutAllTexts = () => {
            let headline = null,
                qFunction = null,
                institution = null,
                height = null;

            // Set Height
            const quoteContent = document.querySelectorAll('.quote-content[data-heightset]');

            Array.from(quoteContent).forEach(element => {
                headline = getOuterHeightOfElement(element.querySelector('.quote-headline'));
                qFunction = getOuterHeightOfElement(element.querySelector('.quote-function'));
                institution = getOuterHeightOfElement(element.querySelector('.quote-institution'));

                height = 268 - headline - qFunction - institution;


                const textTrimmed = element.querySelector('.quote-text__trimmed');
                if (textTrimmed) {
                    textTrimmed.style.height = height + 'px';
                }

                const textCollection = element.querySelector('.quote-text-collection');
                if (textCollection) {
                    textCollection.style.minHeight = height + 'px';
                }

                // Cut the text
                shave(element.querySelector('.quote-text__trimmed'), height);
            });

            Array.from(document.querySelectorAll('.quote-column-wrapper')).forEach(element => {
                if (element.dataset.hasmedia === '0' && element.querySelector('.quote-text__trimmed')) {
                    const readMoreBox = element.querySelector('.quote-read-more-box');

                    if (element.querySelector('.quote-text__trimmed').textContent === element.querySelector('.quote-text__full').textContent) {
                        readMoreBox.classList.add('d-none');
                    }
                    else {
                        readMoreBox.classList.remove('d-none');
                    }
                }
            });
        }

        /**
         * Event-Listener for all Quotes when they clicked
         */
        const createEventListeners = () => {
            const body = $('body');

            $(body).on('click', '.quote-read-more-box', function () {
                expandQuote(this);
            });

            $(body).on('click', '.accordion-header', function () {
                setTimeout(cutAllTexts, 300);
            });

            $(window).on('resize', function () {
                const quoteContent = document.querySelectorAll('.quote-content[data-heightset]');

                Array.from(quoteContent).forEach(element => {
                    // Replace Text with the original
                    element.querySelector('.quote-text__trimmed').textContent = element.querySelector('.quote-text__full').textContent;
                });

                cutAllTexts();
            });
        }

        // If Quote List exists
        if (document.querySelector('.quotes-list') !== null) {
            const rows = parseInt(document.querySelector('.quotes-list').dataset.rows);
            const limit = parseInt(document.querySelector('.quotes-list').dataset.limit);
            const endlessScroll = parseInt(document.querySelector('.quotes-list').dataset.endlessscroll) === 1;

            // the keys are the valid categories
            let loading = {
                medicalControlling: false,
                compliance: false,
                leistungserbringung: false,
                geschaeftsfuehrung: false,
                itLeitung: false
            };

            /**
             * Load Quotes by Category and attach them
             *
             * @param category
             */
            const loadQuotesByCategory = (category) => {
                const categoryCollection = document.getElementById('quoteCollection_' + category);
                const offset = parseInt(categoryCollection.dataset.offset);

                if (loading[category] || offset >= limit) {
                    return;
                }

                loading[category] = true;

                let url = window._AVENCY_BASE_actions.quotesList;

                url += category !== '' ? '&category=' + category : '';
                url += '&rows=' + rows;
                url += '&offset=' + offset;
                url += '&limit=' + limit;

                const request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400 && this.response !== '') {
                        if (endlessScroll && offset > 0) {
                            const newDom = document.createElement('div');

                            newDom.innerHTML = this.response;
                            document.getElementById('quotelistListing_' + category).appendChild(newDom);
                        } else {
                            document.getElementById('quotelistListing_' + category).innerHTML = this.response;
                        }

                        loading[category] = false;
                        categoryCollection.dataset.offset = (offset + rows).toString();
                        cutAllTexts();

                        if (window.lazyLoadObject instanceof window.LazyLoad) {
                            window.lazyLoadObject.update();
                        }
                    }
                };
                request.send();
            }

            /**
             * Check if category bottom is in viewport and opened
             *
             * @param category
             * @returns {boolean}
             */
            const isCategoryInViewportAndOpened = (category) => {
                const accordionHeader = document.querySelector('#quoteCollection_' + category + ' .accordion-header');
                if (!accordionHeader) {
                    return false;
                }

                const isOpen = accordionHeader.classList.contains('opened');
                if (!isOpen) {
                    return false;
                }

                const endlessScrollElement = document.getElementById('quotelist_endlessscroll_' + category);
                const bounding = endlessScrollElement.getBoundingClientRect();

                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            if (document.querySelector('.quote-list-header') !== null) {
                $('.quote-list-header__item').on('click', '.trigger-quote-collection', function () {
                    let boundingElementId = $(this).parents().closest('.quote-list-header__item').data('target');

                    $('#' + boundingElementId).collapse('show');
                    window.setTimeout(function () {
                            $([document.documentElement, document.body]).scrollTop($('#' + boundingElementId + '_title').offset().top - $('.navbar').height() - 60)
                        },
                        300);
                });
            }

            // If EndlessScroll is activated
            if (endlessScroll) {
                let loadingKey;
                window.addEventListener('scroll', function () {
                    // Use the keys of `loading` to check if the category is opened and is in viewport
                    for (loadingKey in loading) {
                        if (isCategoryInViewportAndOpened(loadingKey)) {
                            loadQuotesByCategory(loadingKey);
                        }
                    }
                }, {passive: true});
            }

            if (!endlessScroll) {
                window.addEventListener('click', function (event) {
                    if (event.target.classList.contains('load-more-quotes')) {
                        loadQuotesByCategory((event.target).getAttribute('data-category'));
                    }
                }, {passive: true});
            }
        }

        cutAllTexts();
        createEventListeners();
    }
})(jQuery, window, document);
